<div class="mt-5">
    <div fxLayout="column">
        <div class="col-md-12">
            <span evkMatHeadLine>Validación archivo requerimiento</span>
        </div>
        <div fxLayout="column">
            <div class="col-md-12">
                <span class="mat-subheading-1 mat-body-strong ng-star-inserted">Cargue su archivo .req</span>
            </div>
            <form [formGroup]="this.formReq">
                <mat-form-field appearance="outline" fxFlex="80%">
                    <mat-label>Archivo(.req)</mat-label>
                    <ngx-mat-file-input
                        required
                        formControlName="archivoReq"
                        [accept]="'.req'"
                        (change)="handleFileSelect($event)">
                    </ngx-mat-file-input>
                    <mat-icon matSuffix>folder</mat-icon>
                    <mat-icon *ngIf="this.showValidIcon"
                              class="icon-size-5"
                              matSuffix
                              [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                    <mat-icon *ngIf="this.showInvalidIcon"
                              class="icon-size-5"
                              matSuffix
                              [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
                </mat-form-field>
            </form>
            <div *ngIf="errorFile" class="error-component">
                <span>
                    {{ errorMessage }}
                </span>
            </div>
        </div>
    </div>

</div>
